module.exports = __webpack_public_path__ + "crab.jpg?2dfc38cb59e2767b4dacd68fb0184824";